import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStory } from './StoryContext';
export const Navigation = () => {
  const navigate = useNavigate();
  const {
    isLoggedIn,
    setIsLoggedIn
  } = useStory();
  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_email');
    setIsLoggedIn(false);
    navigate('/');
  };
  return <nav className="bg-[#FFFAE4] shadow-sm relative" data-id="element-745">
      {/* Lined paper background overlay */}
      <div className="absolute inset-0 opacity-[0.124]" style={{
      backgroundImage: `repeating-linear-gradient(#FFFAE4, #FFFAE4 31px, #A5CFFA 31px, #A5CFFA 32px)`,
      backgroundSize: '100% 32px',
      backgroundPosition: '0 10px'
    }} data-id="element-746"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-747">
        <div className="flex justify-between items-center h-[50.7px] py-[4.225rem]" data-id="element-748">
          {/* Left section - The Story Garden */}
          <div className="flex items-center h-[75%]" data-id="element-749">
            <Link to="/garden" className="px-3 py-2 text-[#0A1E3A] hover:bg-[#FFF0E6] rounded-full transition-colors text-sm md:text-base font-medium font-league-spartan whitespace-nowrap" data-id="element-750">
              The Story Garden
            </Link>
          </div>
          {/* Center section - Logo and main navigation */}
          <div className="flex items-center justify-center" data-id="element-751">
            <Link to="/" className="px-3 py-2 text-[#0A1E3A] hover:bg-[#FFF0E6] rounded-full transition-colors text-base md:text-xl font-medium font-league-spartan whitespace-nowrap" data-id="element-752">
              STORYBUNNY.AI
            </Link>
            <Link to="/" className="flex items-center justify-center mx-1" data-id="element-753">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/418zCrtRHUswKm66RYs3wy/ChatGPT_Image_Jul_19%2C_2025_at_12_01_23_AM.png" alt="Story Bunny Logo" className="w-35 h-35 md:w-56 md:h-56" data-id="element-754" />
            </Link>
            <Link to="/" className="px-3 py-2 text-[#0A1E3A] hover:bg-[#FFF0E6] rounded-full transition-colors text-base md:text-xl font-medium font-league-spartan whitespace-nowrap" data-id="element-755">
              CREATE YOUR POTTY STORY
            </Link>
          </div>
          {/* Right section - Log In | Sign Up */}
          <div className="flex items-center h-[75%]" data-id="element-756">
            <Link to="/login" className="px-3 py-2 text-[#0A1E3A] hover:bg-[#FFF0E6] rounded-full transition-colors text-sm md:text-base font-medium font-league-spartan whitespace-nowrap" data-id="element-757">
              Log In | Sign Up
            </Link>
          </div>
        </div>
      </div>
    </nav>;
};